module.exports = __webpack_public_path__ + "img/sample-report-08@3x.ab261b95.png";